import React from 'react';
import './columnHeader.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';
import { AonTooltip } from '../../../components/core/AonTooltip';
import { formatDate } from '../../../constants/utilities';
var ColumnTitle;
(function (ColumnTitle) {
    ColumnTitle["aon_ID"] = "Aon ID";
    ColumnTitle["market_type"] = "Market Name";
    ColumnTitle["Domiciled_Country"] = "Domiciled Country";
    ColumnTitle["additional_info"] = "Additional Information";
    ColumnTitle["date_of_action"] = "Date Of Action";
    ColumnTitle["ActionType"] = "Action Type";
    ColumnTitle["current"] = "Current";
    ColumnTitle["prior"] = "Prior";
})(ColumnTitle || (ColumnTitle = {}));
export var columns = function (handleSorting, sortColumn, sortBy, isLoading) {
    var headerConfig = function (headerProps) {
        var classsName = sortColumn === headerProps.column.colId ? "sorting-".concat(sortBy, " active sorting-height") : "sorting sorting-height";
        return (React.createElement("div", { onClick: function () { return isLoading ? null : handleSorting(headerProps.column.colId); }, className: classsName },
            React.createElement("span", null, headerProps.displayName)));
    };
    var RegionCell = function (info) {
        var rowData = info.data;
        var displayFlag = !(rowData === null || rowData === void 0 ? void 0 : rowData.region) && !(rowData === null || rowData === void 0 ? void 0 : rowData.marketType) && !(rowData === null || rowData === void 0 ? void 0 : rowData.reinsuranceIndicator) &&
            !(rowData === null || rowData === void 0 ? void 0 : rowData.marketGuideStatus);
        return (!displayFlag ?
            React.createElement("span", null,
                React.createElement(FontAwesomeIcon, { className: 'info-icon', icon: faCircleInfo })) : null);
    };
    var DateChangeUTC = function (info) { return (React.createElement("span", null, formatDate(new Date(info.getValue())))); };
    var ChangedToCell = function (info) { return (React.createElement("span", null, info.getValue().length < 25 ? info.getValue() :
        React.createElement("span", null,
            React.createElement(AonTooltip, { text: info.getValue(), width: 'md', darkMode: false, position: 'right', children: "".concat(info.getValue().substring(0, 25), "...") })))); };
    var ChangedFrom = function (info) {
        var rowData = info.data;
        var element = (rowData === null || rowData === void 0 ? void 0 : rowData.actionTaken) === "Permitted Use" && (rowData === null || rowData === void 0 ? void 0 : rowData.changedFrom) ?
            React.createElement("span", null,
                React.createElement(AonTooltip, { text: rowData === null || rowData === void 0 ? void 0 : rowData.changedFrom, width: 'md', darkMode: false, position: 'right', children: React.createElement(React.Fragment, null,
                        React.createElement(FontAwesomeIcon, { className: 'info-icon', icon: faCircleInfo })) }))
            :
                React.createElement("span", null, info.getValue());
        return (element);
    };
    var CenterAlline = {
        display: "flex",
        justifyContent: "center"
    };
    return ([
        { cellStyle: CenterAlline, headerClass: "grid-header-center", field: "marketId", headerName: ColumnTitle.aon_ID, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 150 },
        { field: "marketName", headerName: ColumnTitle.market_type, sortable: false, headerComponent: headerConfig, flex: 2, minWidth: 150 },
        { field: "domiciledCountry", headerName: ColumnTitle.Domiciled_Country, sortable: false, headerComponent: headerConfig, flex: 1, minWidth: 130 },
        { cellStyle: CenterAlline, field: "region", headerName: ColumnTitle.additional_info, cellRenderer: RegionCell, tooltipComponent: "RecentChangesRegionTooltip", tooltipField: "region", sortable: false, flex: 0.5, minWidth: 120 },
        { field: "dateChangedUTC", headerName: ColumnTitle.date_of_action, cellRenderer: DateChangeUTC, sortable: false, headerComponent: headerConfig, flex: 0.5, minWidth: 130 },
        { field: "actionTaken", headerName: ColumnTitle.ActionType, sortable: false, flex: 1.5, minWidth: 150 },
        { field: "changedTo", headerName: ColumnTitle.current, cellRenderer: ChangedToCell, sortable: false, flex: 1.5, minWidth: 150 },
        { field: "changedFrom", headerName: ColumnTitle.prior, cellRenderer: ChangedFrom, sortable: false, flex: 0.5, minWidth: 120 }
    ]);
};
